import type { ICitation } from "@/api";
import type { ReferenceItem } from "./attachment-pill-row.utils";

export type AttachmentAction =
    | "view-highlights"
    | "view-scope"
    | "view-folder"
    | "view-comparison"
    | "view-document-library"
    | "export-scope"
    | "export-comparison";

export interface AttachmentActionDeps {
    openDocument: (source: ICitation, page?: number) => void;
    onExportScope?: (scopeId: number) => void;
    onExportComparison?: (comparisonId: number) => void;
    /** When ref has no attached citation, look up by document_id. */
    citationFallback?: ICitation[];
}

function findCitation(
    ref: ReferenceItem,
    deps: AttachmentActionDeps
): ICitation | undefined {
    return (
        ref.citation ??
        deps.citationFallback?.find((c) => c.document_id === ref.id)
    );
}

export function handleAttachmentAction(
    ref: ReferenceItem,
    action: AttachmentAction,
    deps: AttachmentActionDeps
): void {
    switch (action) {
        case "view-highlights": {
            const citation = findCitation(ref, deps);
            if (citation) deps.openDocument(citation);
            return;
        }
        case "view-scope": {
            const id = ref.attachment?.attachment_id ?? ref.id;
            window.open(`/organizations/scopes/${id}`, "_blank");
            return;
        }
        case "view-folder":
            window.open(
                `/organizations/document-library/documents/folder/${ref.id}`,
                "_blank"
            );
            return;
        case "view-comparison": {
            const id = ref.attachment?.attachment_id ?? ref.id;
            window.open(`/organizations/comparisons/${id}`, "_blank");
            return;
        }
        case "view-document-library": {
            const tab = findCitation(ref, deps)?.shared_by_organization_name
                ? "knowledge-base"
                : "documents";
            window.open(
                `/organizations/document-library/${tab}?doc=${ref.id}`,
                "_blank"
            );
            return;
        }
        case "export-scope": {
            const id = ref.attachment?.attachment_id ?? ref.id;
            deps.onExportScope?.(id);
            return;
        }
        case "export-comparison": {
            const id = ref.attachment?.attachment_id ?? ref.id;
            deps.onExportComparison?.(id);
            return;
        }
    }
}
